import type { ApiConfig } from '../../types/config';
/**
 * Default API configuration
 */
const DEFAULT_API_CONFIG: ApiConfig = {
  dynamicFlowUrl:
    typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_DYNAMIC_FLOW_API
      ? process.env.NEXT_PUBLIC_DYNAMIC_FLOW_API
      : 'https://dynamic-flows.api.highereducation.com',
  audienceIntentApiUrl:
    typeof process !== 'undefined' && process.env?.AUDIENCE_INTENT_API
      ? process.env.AUDIENCE_INTENT_API
      : 'https://audience-intent.api.highereducation.com',
  mobiusApiUrl:
    typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_MOBIUS_API_URL
      ? process.env?.NEXT_PUBLIC_MOBIUS_API_URL
      : 'https://api.mobius.highereducation.com',
  organizationApiUrl:
    typeof process !== 'undefined' &&
    process.env?.NEXT_PUBLIC_ORGANIZATION_API_BASE_URL
      ? process.env.NEXT_PUBLIC_ORGANIZATION_API_BASE_URL
      : 'https://organizations.api.highereducation.com',
  campaignManagementApiUrl:
    typeof process !== 'undefined' &&
    process.env?.CAMPAIGN_MANAGEMENT_API_BASE_URL
      ? process.env.CAMPAIGN_MANAGEMENT_API_BASE_URL
      : 'https://campaign-management.api.highereducation.com',
  deliverySystemApiUrl:
    typeof process !== 'undefined' && process.env?.DELIVERY_SYSTEM_API_BASE_URL
      ? process.env.DELIVERY_SYSTEM_API_BASE_URL
      : 'https://delivery-system.staging.rveducation.io',
  offeringsSearchApiUrl:
    typeof process !== 'undefined' && process.env?.OFFERING_SERVICE_BASE_URL
      ? process.env?.OFFERING_SERVICE_BASE_URL
      : 'https://offerings.int.api.highereducation.com',
  offeringsServiceBaseUrl:
    typeof process !== 'undefined' && process.env?.OFFERINGS_SERVICE_BASE_URL
      ? process.env.OFFERINGS_SERVICE_BASE_URL
      : 'https://offerings-service.int.api.highereducation.com',
  sitePublishingBaseUrl:
    typeof process !== 'undefined' &&
    process.env?.NEXT_PUBLIC_SITE_PUBLISHING_BASE_URL
      ? process.env?.NEXT_PUBLIC_SITE_PUBLISHING_BASE_URL
      : '',
  prospectServiceApiUrl:
    typeof process !== 'undefined' &&
    process.env?.NEXT_PUBLIC_PROSPECT_SERVICE_BASE_URL
      ? process.env.NEXT_PUBLIC_PROSPECT_SERVICE_BASE_URL
      : typeof process !== 'undefined' && process.env?.PROSPECT_SERVICE_BASE_URL
        ? process.env.PROSPECT_SERVICE_BASE_URL
        : '',
  leadApiBaseUrl:
    typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_LEAD_API_BASE_URL
      ? process.env.NEXT_PUBLIC_LEAD_API_BASE_URL
      : '',
  locationInferenceApiUrl:
    typeof process !== 'undefined' &&
    process.env?.NEXT_PUBLIC_LOCATION_INFERENCE_API_URL
      ? process.env.NEXT_PUBLIC_LOCATION_INFERENCE_API_URL
      : '',
};

let apiConfig: ApiConfig = { ...DEFAULT_API_CONFIG };

/**
 * Configure the API client with custom endpoints
 */
export function configureApiClient(config: Partial<ApiConfig>): void {
  apiConfig = { ...apiConfig, ...config };
}

/**
 * Get the current API configuration
 */
export function getApiConfig(): ApiConfig {
  return { ...apiConfig };
}

/**
 * Build URL for flow endpoint
 */
export function buildFlowUrl(tenantId: string, flowId: string): string {
  const baseUrl = apiConfig.dynamicFlowUrl;
  return `${baseUrl}/v1/tenants/${tenantId}/flows/${flowId}`;
}

/**
 * Build URL for audience intent endpoint
 */
export function buildAudienceIntentUrl(
  tenantId: string,
  postId: string,
): string {
  const baseUrl = apiConfig.audienceIntentApiUrl;
  return `${baseUrl}/v1/intents/profiles/tenants/${tenantId}/posts/${postId}`;
}

/**
 * Build URL for question endpoint
 */
export function buildQuestionUrl(tenantId: string, questionId: string): string {
  const baseUrl = apiConfig.dynamicFlowUrl;
  return `${baseUrl}/v1/tenants/${tenantId}/questions/${questionId}`;
}

export default {
  configureApiClient,
  getApiConfig,
  buildFlowUrl,
  buildAudienceIntentUrl,
  buildQuestionUrl,
};
